const problems = [
  {
    icon: "ri-time-line",
    text: "Dienstleister kommen zu spät oder gar nicht.",
  },
  {
    icon: "ri-emotion-unhappy-line",
    text: "Die Qualität stimmt nicht und Beschwerden häufen sich.",
  },
  {
    icon: "ri-user-search-line",
    text: "Sie müssen mehreren Firmen hinterherlaufen.",
  },
  {
    icon: "ri-phone-line",
    text: "Und wenn es wirklich dringend ist, ist niemand erreichbar.",
  },
];

export default function ProblemSection() {
  return (
    <section className="py-24 md:py-32 bg-[#F9F7F4]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-16 lg:gap-24 items-start">
          {/* Left */}
          <div className="lg:w-[38%]">
            <span className="text-xs font-bold tracking-widest uppercase text-gray-400 mb-4 block">Das Problem</span>
            <h2 className="text-4xl md:text-5xl font-bold text-black leading-tight mb-6" style={{ fontFamily: "'Inter', sans-serif" }}>
              Kommt Ihnen das bekannt vor?
            </h2>
            <p className="text-gray-500 text-base leading-relaxed">
              Viele Immobilieneigentümer und -verwalter kennen diese Situation nur zu gut. Unzuverlässige Dienstleister kosten Zeit, Geld und Nerven.
            </p>
          </div>

          {/* Right */}
          <div className="lg:w-[62%] flex flex-col gap-4">
            {problems.map((p, i) => (
              <div
                key={i}
                className={`bg-white rounded-xl p-4 md:p-5 flex items-start gap-4 transition-all hover:-translate-y-0.5 ${
                  i % 2 === 1 ? "lg:ml-10" : ""
                }`}
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-red-50 flex-shrink-0">
                  <i className={`${p.icon} text-red-500 text-lg`}></i>
                </div>
                <p className="text-gray-700 text-base leading-relaxed pt-1.5">{p.text}</p>
              </div>
            ))}

            {/* Conclusion */}
            <div className="bg-black rounded-xl p-4 md:p-5 flex items-center gap-4 lg:ml-10">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 flex-shrink-0">
                <i className="ri-arrow-right-circle-line text-white text-lg"></i>
              </div>
              <p className="text-white font-semibold text-base">
                Genau hier setzen wir an.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
